import { Component, OnInit } from '@angular/core';
import { SurveyQuestionVm } from '../models/surveyquestionVm';
import { SurveyService } from "../services/survey.service";
import { environment } from '../../environments/environment';
import { LocalstorageService } from '../services/localstorage.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DataService } from '../services/GlobalService/data.service';

@Component({
  selector: 'app-spark-moment-survey',
  templateUrl: './spark-moment-survey.component.html',
  styleUrls: ['./spark-moment-survey.component.css']
})
export class SparkMomentSurveyComponent implements OnInit {

  questions: SurveyQuestionVm[];
  isIpAllowed: boolean = false;
  isVerified: boolean = false;
  currentPageToRedirect: string = '';
  constructor(
    private localstorageService: LocalstorageService,
    private surveyService: SurveyService,
    private router: Router,
    private dataService: DataService) { }
  showWelcomeText: boolean = true;
  env: string;
  redirectToHome: boolean;
  //isAuthenticated: boolean;
  async ngOnInit() {
    this.env = environment.headerBanner;
    this.redirectToHome = false;
    this.isVerified = this.localstorageService.isVerified();
    //this.isAuthenticated = this.localstorageService.isAuthenticated();
    if (!this.isVerified) { //&& !this.isAuthenticated) {
      
      console.log("Page Redirection set.");
      this.IsRedirectedToVerify();
      return;
    } else {
      this.router.navigateByUrl('/spark-moment-survey');
    }
    this.questions = await this.surveyService.GetSparkySurveyFormQuestions().toPromise();
    console.log("Check Qustn: ",this.questions);
  }
  IsRedirectedToVerify() {
    this.currentPageToRedirect = '/spark-moment-survey';
    this.dataService.setCurrentPageToRedirect(this.currentPageToRedirect);
    this.dataService.setShowHeaderForSPARK(true);
    //alert("Spark Comp : Page Redirection Set: " + this.currentPageToRedirect);
    this.router.navigateByUrl('/verify/survey');
  }
  hideWelcomeText() {
    this.showWelcomeText = false;
  }
  onLogout() {
    this.router.navigate(["/logout"]);
  }
}
